import { redirectWithGet, redirectWithPost } from '../../../shared/api/redirect/redirect.js';
import { validateSession, INCONSISTENT_ACCESS_CREDENTIALS } from '../api/validateSession.js';
import { validateResolution } from '../api/validateResolution.js';

export async function onRegisterSession(registerData, tokena, eForm) {
  // IMPORTANTE registerSession OK > setTokena
  sessionStorage.setItem('tokena', tokena);

  // 12/2023: Añadimos lógica de redirecciones al validar la sesión y se calcule en el servidor
  const redirection = checkRedirection(registerData, eForm);
  const userInfo = await validateSession(registerData, redirection);
  if (!userInfo) {
    throw new Error(INCONSISTENT_ACCESS_CREDENTIALS);
  }

  const isValidResolution = await validateResolution();
  if (!isValidResolution) {
    // Go to custom alert (de momento sólo permite get)
    redirectWithGet('/alert/insufficientResolution');
  } else {
    const url = getUrl(userInfo);
    const urlParams = new URLSearchParams(window.location.search);
    // user data > necesario para sobrescribir siempre lo de la url

    setUser(userInfo, registerData, urlParams);
    registerData?.domain && urlParams.set('domain', registerData.domain);
    registerData?.group && urlParams.set('group', registerData.group);
    // typeAccess data
    registerData?.samlAccess && urlParams.set('samlAccess', true);
    registerData?.certAccess && urlParams.set('certAccess', true);
    registerData?.token_type && urlParams.set('token_type', registerData.token_type);
    // token login/ediwin
    setToken(url, urlParams, tokena);

    registerSessionSuccess(eForm, url, urlParams);
  }
}

function registerSessionSuccess(eForm, url, urlParams) {
  return eForm ? submitForm(eForm, url, urlParams) : redirectWithPost(`${url}?${urlParams}${location.hash ?? ''}`);
}

// 09/2024: Ampliamos redirección para login desde el formulario y samlAccess
function checkRedirection(registerData, eForm) {
  return registerData?.samlAccess || !!eForm;
}

// 12/2023 Redirección
function getUrl(userInfo) {
  return userInfo.instanceUrl ? `${userInfo.instanceUrl}login` : '/app';
}

// 05/2025 Enviamos el user por si redireccionamos a instancias antiguas de login (7.18)
function setUser(userInfo, registerData, urlParams) {
  if (userInfo.instanceUrl && !registerData?.user) {
    // Solo se dará en samlAccess || certAccess
    urlParams.set('user', userInfo.userId);
  } else {
    registerData?.user && urlParams.set('user', registerData.user);
  }
}

function setToken(url, urlParams, tokena) {
  urlParams.set(url.endsWith('/app') ? 'tokena' : 'token', tokena);
}

// 12/2023 NUEVO: Solución remember user + pass
function submitForm(eForm, url, urlParams) {
  // flag submit = app con ?
  eForm.action = `${url}?${location.hash ?? ''}`;

  // NOTA: Incluímos user data no afecta a lo que ya incluye el form-login (appController#params)
  eForm.insertAdjacentHTML('beforeend', getFormInputHTML(urlParams));

  // Necesario para que el navegador gestione las contraseñas
  eForm.submit();
}

function getFormInputHTML(urlParams) {
  let html = '';

  for (const [name, value] of urlParams.entries()) {
    html += getInputHTML(name, value);
  }

  return html;
}

function getInputHTML(name, value) {
  return `<input type="hidden" name="${name}" value="${decodeURIComponent(value)}">`;
}
